<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" lg="10" xl="8">
        <v-card shaped>
          <NewsSlider />
          <v-card-text>
            <v-row justify="center" align="center">
              <v-col cols="12" lg="6" class="text-center">
                <div v-if="editorial" v-html="editorial"></div>
                <h1 v-else class="h1">Bienvenue sur le portail de votre centre</h1>
              </v-col>
              <v-col  cols="12" lg="6">
                <LastDocuments />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    
  </v-container>
</template>

<script>
import LastDocuments from '@/components/Document/LastDocuments'
import NewsSlider from '@/components/News/NewsSlider'
import { mapState } from 'vuex'
export default {
  name: 'MyHome',
  components: { LastDocuments, NewsSlider },
  computed: {
    ...mapState('auth', [
      'user'
    ]),
    editorial () {
      if (this.user.mall && this.user.mall.editorial && this.user.mall.editorial !== '<p></p>') {
        return this.user.mall.editorial
      }
      return null
    }
  }
}
</script>

